import { clear } from "@testing-library/user-event/dist/clear";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const COOKIE_OPTIONS = {
  path: "/",
};

export const setAuthCookies = ({ token, user, role }) => {
  Cookies.set("token", token, {
    expires: 1,
    ...COOKIE_OPTIONS,
  });

  Cookies.set("user", JSON.stringify(user), {
    expires: 1,
    ...COOKIE_OPTIONS,
  });

  if (role) {
    Cookies.set("role", role, {
      expires: 1,
      ...COOKIE_OPTIONS,
    });
  }
};

export const clearAuthCookies = () => {
  Cookies.remove("token", COOKIE_OPTIONS);
  Cookies.remove("user", COOKIE_OPTIONS);
};

export const isTokenValid = ()=> {
    const token = Cookies.get("token");
    if(!token)
        {
        clearAuthCookies();
        return false;
    }

    try
    {
        const decoded = jwtDecode(token);
        const isValid = decoded.exp * 1000 > Date.now();
        if(!isValid)
        {
            clearAuthCookies();
        }
        return isValid;
    }
    catch
    {
        clearAuthCookies();
        return false;
    }
};
